import { gql } from "@apollo/client";

export const SLACK_LOGIN = gql`
  mutation SLACK_LOGIN($code: String!) {
    slackGoldwareUserLogin(code: $code) {
      token
    }
  }
`;
